module.exports = __webpack_public_path__ + "static/zoe-web-samsung@3x-65c2558ce27fcad27c91643de1f585fa.jpg";